import "scripts/templates/page.international-login.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.international-login");
